export function isLocalHost() {
  const { port } = new URL(window.location.href);
  return port === '3000';
}
